import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import isFunction from 'lodash/isFunction';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import s from './BaseInput.scss';
const BaseInput = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { isRequired , className  } = _param, rest = _object_without_properties(_param, [
        "isRequired",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(BiInput, _extends({
        className: c(s['input'], className),
        required: isRequired,
        innerRef: (node)=>{
            if (isFunction(ref)) {
                ref(node);
            } else if (ref) {
                ref.current = node;
            }
        }
    }, rest));
});
BaseInput.displayName = 'BaseInput';
export default BaseInput;
